import { createRoutine } from 'redux-saga-routines';

export const pageLoading = createRoutine('PAGE_LOADING');
export const pageReloading = createRoutine('PAGE_RELOADING');
